import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Bet } from '@/results/results.api';

/** GS-901 — VOID_BETS (MATCH-ODDS-ENGINE.md §7.4): the market's bets, newest first; the operator ticks the ones to void. */
@Component
export default class BetsDialog extends Vue {
  @Prop({ default: false }) readonly open!: boolean;
  @Prop({ default: '' }) readonly marketName!: string;
  @Prop({ default: (): Bet[] => [] }) readonly bets!: Bet[];
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: '' }) readonly error!: string;
  @Prop({ default: false }) readonly busy!: boolean;

  private picked: Record<number, boolean> = {};
  private reason = '';

  get count(): number {
    return Object.keys(this.picked).filter((id) => this.picked[Number(id)]).length;
  }

  get canConfirm(): boolean {
    return !this.busy && this.count > 0 && this.reason.trim().length > 0;
  }

  @Watch('open')
  onOpen(open: boolean): void {
    if (open) {
      this.picked = {};
      this.reason = '';
    }
  }

  toggle(bet: Bet): void {
    if (bet.voidReason || this.busy) {
      return;
    }
    this.picked = Object.assign({}, this.picked, { [bet.betId]: !this.picked[bet.betId] });
  }

  time(placedAt: string): string {
    return (placedAt || '').replace(/\.\d+$/, '').slice(5, 16);
  }

  cancel(): void {
    if (!this.busy) {
      this.$emit('cancel');
    }
  }

  confirm(): void {
    if (this.canConfirm) {
      const betIds = Object.keys(this.picked).filter((id) => this.picked[Number(id)]).map(Number).sort((a, b) => a - b);
      this.$emit('confirm', { betIds, reason: this.reason.trim() });
    }
  }
}
